import React from 'react';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import HomeOutlined from '@mui/icons-material/HomeOutlined';
import StickyNote2Icon from '@mui/icons-material/StickyNote2Outlined';
import Add from '@mui/icons-material/AddCircleOutlineOutlined';
import User from '@mui/icons-material/PersonOutlineOutlined';

const NormalButton = styled(Button)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  fontSize: '20px',
  textTransform: 'initial',
  color: 'black',
  fontWeight: 'bold',
  '&:hover': {
    color: '#ddb930',
    boxShadow: 'none',
  },
  boxShadow: 'none',
}));

const PressedButton = styled(Button)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  fontSize: '20px',
  textTransform: 'initial',
  fontWeight: 'bold',
  color: '#ddb930',
  '&:hover': {
    color: '#ddb930',
    boxShadow: 'none',
  },
  boxShadow: 'none',
}));

interface menuButtonProps {
  isPressed?: boolean;
  type: string;
  text: string;
}

const MenuButton: React.FC<menuButtonProps> = ({ isPressed, type, text }) => {
  return isPressed ? (
    <PressedButton>
      {type === 'home' ? (
        <HomeOutlined />
      ) : type === 'create' ? (
        <Add />
      ) : type === 'fund' ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="17"
          viewBox="0 0 16 13"
          style={{ paddingTop: '1px', color: '#ddb930' }}
        >
          <g
            id="Icon_feather-inbox"
            data-name="Icon feather-inbox"
            transform="translate(-2.5 -5.5)"
          >
            <path
              id="Path_440"
              data-name="Path 440"
              d="M18,18H13.5L12,20.25H9L7.5,18H3"
              transform="translate(0 -6)"
              fill="none"
              stroke="#c1c1c1"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
            />
            <path
              id="Path_441"
              data-name="Path 441"
              d="M5.588,6.832,3,12v4.5A1.5,1.5,0,0,0,4.5,18h12A1.5,1.5,0,0,0,18,16.5V12L15.413,6.832A1.5,1.5,0,0,0,14.07,6H6.93a1.5,1.5,0,0,0-1.343.832Z"
              fill="none"
              stroke="#c1c1c1"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
            />
          </g>
        </svg>
      ) : type === 'wiki' ? (
        <StickyNote2Icon sx={{ color: 'white' }} />
      ) : (
        <User />
      )}
      <Typography>{text}</Typography>
    </PressedButton>
  ) : (
    <NormalButton>
      {type === 'home' ? (
        <HomeOutlined sx={{ color: 'white' }} />
      ) : type === 'create' ? (
        <Add sx={{ color: 'white' }} />
      ) : type === 'fund' ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="17"
          viewBox="0 0 16 13"
          style={{ paddingTop: '1px', color: '#ddb930' }}
        >
          <g
            id="Icon_feather-inbox"
            data-name="Icon feather-inbox"
            transform="translate(-2.5 -5.5)"
          >
            <path
              id="Path_440"
              data-name="Path 440"
              d="M18,18H13.5L12,20.25H9L7.5,18H3"
              transform="translate(0 -6)"
              fill="none"
              stroke="#c1c1c1"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
            />
            <path
              id="Path_441"
              data-name="Path 441"
              d="M5.588,6.832,3,12v4.5A1.5,1.5,0,0,0,4.5,18h12A1.5,1.5,0,0,0,18,16.5V12L15.413,6.832A1.5,1.5,0,0,0,14.07,6H6.93a1.5,1.5,0,0,0-1.343.832Z"
              fill="none"
              stroke="#c1c1c1"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
            />
          </g>
        </svg>
      ) : type === 'wiki' ? (
        <StickyNote2Icon sx={{ color: 'white' }} />
      ) : (
        <User sx={{ color: 'white' }} />
      )}
      <Typography>{text}</Typography>
    </NormalButton>
  );
};

export default MenuButton;
